import FooterContactWheel from "@/components/FooterContactWheel";
import { useBranding } from "@/contexts/BrandingContext";

/**
 * FloatingContactDock
 *
 * Stacked just above the Fahad avatar on the bottom-left of the viewport so
 * it follows the customer as they scroll. Holds the blooming contact wheel
 * (Phone / Chat / Map) — same widget that previously lived in the footer.
 */
export default function FloatingContactDock() {
  const { branding } = useBranding();
  const phone = branding.contact_phone || "";
  const wa = branding.whatsapp_number || phone;
  const mapUrl = branding.location_url || "";

  if (!phone && !wa && !mapUrl) return null;

  return (
    <div
      data-testid="floating-contact-dock"
      style={{
        position: "fixed",
        left: "20px",
        bottom: "98px",   // sits directly above FloatingFahad (≈62px + 16px gap)
        zIndex: 40,
        pointerEvents: "none",
      }}
    >
      <div style={{ pointerEvents: "auto" }}>
        <FooterContactWheel phone={phone} whatsapp={wa} locationUrl={mapUrl} />
      </div>
    </div>
  );
}
